<template>
  <el-dialog
    :visible="visible"
    title="在线留言板"
    width="660px"
    destroy-on-close
    :before-close="close"
    :close-on-click-modal="false"
    :modal="false"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="99px">
      <el-form-item label="标题:" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="联系人:" prop="contacts">
        <el-input
          v-model="form.contacts"
          placeholder="请输入联系人姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话:" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="联系人单位:" prop="senderCompanyName">
        <el-input
          v-model="form.senderCompanyName"
          placeholder="请输入联系人单位"
        ></el-input>
      </el-form-item>
      <el-form-item label="留言类型:" prop="messageType">
        <el-select v-model="form.messageType" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="留言内容:" prop="content">
        <el-input
          v-model="form.content"
          type="textarea"
          :rows="3"
          maxlength="300"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="left-btn" @click="cancel">重置</el-button>
      <el-button
        type="primary"
        class="right-btn"
        :disabled="loading"
        @click="submit"
      >
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/modules/projectA/api/messageBoard';

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    setVisible: {
      type: Function,
      default: () => {},
    },
    current: {
      type: Object,
      default: () => {
        return { title: '' };
      },
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    // const validateMobile = (rule, value, callback) => {
    //   const mobileReg = /^0?(11|12|13|15|16|17|18|19|14)[0-9]{9}$/;
    //   console.log(value);
    //   if (value) {
    //     if (!mobileReg.test(value)) {
    //       callback(new Error('请输入正确手机号'));
    //     } else {
    //       callback();
    //     }
    //   } else {
    //     callback();
    //   }
    // };
    return {
      loading: false,
      form: {
        title: '',
        contacts: '',
        mobile: '',
        senderCompanyName: '',
        messageType: '',
        content: '',
      },
      rules: {
        title: [{ required: true, message: '请输入留言标题', trigger: 'blur' }],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur',
          },
        ],
        senderCompanyName: [
          { required: true, message: '请输入联系人公司', trigger: 'blur' },
        ],
        messageType: [
          { required: true, message: '请选择留言类型', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
        ],
        mobile: [
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur',
          },
        ],
      },
      options: [
        { value: 1, label: '商品' },
        { value: 2, label: '订单' },
        { value: 3, label: '询价' },
        { value: 4, label: '物流' },
        { value: 5, label: '支付' },
        { value: 6, label: '招标' },
        { value: 7, label: '其他' },
      ],
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal.realName) {
          const { realName = '', mobile = '', companyName = '' } = newVal;
          this.form.senderCompanyName = companyName;
          this.form.mobile = mobile;
          this.form.contacts = realName;
        }
      },
    },
    content: {
      handler(newVal) {
        console.log(newVal);
        this.form.content = `${window.location.href};${newVal}`;
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    cancel() {
      this.$refs.form.resetFields();
    },
    close() {
      this.cancel();
      this.setVisible(false);
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { replyCompanyId, replyCompanyName } = this.current;
          this.loading = true;
          api
            .addMessage({ ...this.form, replyCompanyId, replyCompanyName })
            .then((res) => {
              this.loading = false;
              if (res.success) {
                this.$message.success({
                  message: '发送成功，请到会员中心我的留言查看回复情况',
                  duration: 1000,
                });
                this.close();
              } else {
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 12px 20px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Source Han Sans CN';
  font-style: normal;

  .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
  }
  .el-dialog__title {
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #333;
  }
}

::v-deep .el-dialog__body {
  padding: 10px 20px 0px 20px;
  height: 330px;
}

::v-deep .el-form-item {
  margin-bottom: 10px;

  .el-input__inner {
    height: 30px;
    line-height: 30px;
  }

  .el-input__count {
    background: #fff;
    height: 0px;
  }

  .el-form-item__error {
    padding-top: 0px;
  }
}
.dialog-footer {
  width: 100%;
  display: flex;
  justify-content: center;

  .left-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 30px;
    border-radius: 0px;
    margin-right: 20px;
    &:hover {
      color: #333;
    }
  }
  .right-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 30px;
    border-radius: 0px;
    background: #2587ff;

    &:hover {
      background: #126edf;
    }
  }
}
</style>
